import { render, staticRenderFns } from "./Sam.vue?vue&type=template&id=6414477e&scoped=true&"
import script from "./Sam.vue?vue&type=script&lang=js&"
export * from "./Sam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6414477e",
  null
  
)

export default component.exports